import { Icon, IconButton, Label } from "@fluentui/react";
import  * as React from "react";
import "./CustomAttachment.scss";
import { languageModal } from "../loc/Clm365ContractManagementWebPartStrings";
// import { languageModal } from "../../loc/Clm365ContractManagementWebPartStrings";
// import * as strings from "Clm365ContractManagementWebPartStrings";
const CustomAttachment = ({
  selectedFile,
  onChangeAdd,
  showLabel=true,
  FileID="file-input",
  onChangeUpdate = (_ev) => {},
  isUpdate = false,
  multiple = undefined,
  accept = undefined,
  label=<></>,
  draggableContainerStyle={} as React.CSSProperties,
  draggableContainerStyle1={} as React.CSSProperties,
}) => {
  const strings = languageModal.getLanguageContent()
  const ref = React.useRef(null);
  const inputRef = React.useRef<any>(null);

  React.useEffect(() => {
    let overlay = document.querySelectorAll(".ms-Overlay");
    let eventListiners = [];
    overlay.forEach((item) => {
      eventListiners.push(
        item.addEventListener("dragover", () => {
          let wrapper = document.querySelector(
            "[data-id='file-input-wrapper']"
          );
          wrapper?.classList.add("hidden");
          
        })
      );
    });
    let InnerContent = document.querySelectorAll(".ms-Panel-contentInner");

    InnerContent.forEach((item) => {
      eventListiners.push(
        item.addEventListener("drop", (ev) => {
          let wrapper = document.querySelectorAll(
            "[data-id='file-input-wrapper']"
          );
          wrapper.forEach((item) => {item.classList.add("hidden");});
          wrapper.forEach((item) => {item.classList.add("b-w-img");});
        }),
        item.addEventListener("dragover", () => {
          let wrapper = document.querySelectorAll(
            "[data-id='file-input-wrapper']"
          );
          wrapper.forEach((item) => {item.classList.remove("hidden");});
          wrapper.forEach((item) => {item.classList.remove("drag_brdr_clr");});
        })
      );
    });

    return () => {
      eventListiners.forEach((curr) => {
        removeEventListener("dragover", curr);
      });
    };
  }, []);
const [drag, setDrag]=React.useState(false);
  const handleDrag = () => {
    ref.current.classList.remove("b-w-img");
    ref.current.classList.remove("hidden");
    ref.current.classList.add("drag_brdr_clr");
    setDrag(true);
  };
  const handleDragLeave = (ev) => {
    ref.current.classList.remove("drag_brdr_clr");
    ref.current.classList.add("b-w-img");
    setDrag(false);
  };
  const handleClick = () => {
    inputRef.current.click();
  };
  //console.log("+++++++++++",drag);
  const DragDropImage: any = require("./AttachmentAreaBGImage.png");
  return (
    <div className="custonAttachment">
      {showLabel ?
      <span className="file-input-label" style={{ display: "flex" }}>
        <Label onClick={handleClick}>{label} </Label>
        <IconButton
          className=""
          iconProps={{ iconName: "Attach" }}
          onClick={handleClick}
        />
      </span>:null}
      <div className="file-input-container" style={draggableContainerStyle} >
        <input
          ref={inputRef}
          id={FileID}
          type="file"
          accept={accept ? accept : undefined}
          onChange={isUpdate ? onChangeUpdate : onChangeAdd}
          className="file-input"
          multiple={multiple}
          onDragOver={handleDrag}
          onDragLeave={handleDragLeave}
        />
        <label
          data-id="file-input-wrapper"
          className=" hidden b-w-img file-input-wrapper "
          style={{height:'30px',width:'99%'}} 
          ref={ref}
          htmlFor={FileID}
          onDrop={(ev) => console.log(ev)}
          onDropCapture={(ev) => console.log(ev)}
        >
          <div className="file-input-icon" style={draggableContainerStyle1}>
            <img className="drop-logo" src={DragDropImage} alt="" style={{width:'15%'}} />
            <div className="" style={{marginTop:'-10px'}}>
               {/* {selectedFile && (multiple || selectedFile.length === 0) && ( */}
               {/* <>
                  <span className="drag_text">{strings.DropYourFilesHere}</span>
                </> */}
              {/* )} */}
              {selectedFile && multiple ? (
                <div>
                 <span className="drag_text">{strings.Dropyourfiles}</span>
                </div>
             ): <span className="drag_text" style={{fontSize:'13px'}}>{strings.DropYourFileHere}</span>} 
            </div>
          </div>
        </label>
      </div>
    </div>
  );
};

export default CustomAttachment;
